import { memo } from 'react';

import PDFIconSVG from '@/assets/pdf-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IPDFIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={PDFIconSVG} {...props} />;

export const PDFIcon = memo(IPDFIcon) as typeof IPDFIcon;
